export default function WholesaleBreakdown({ rows = [] }) {
  if (!Array.isArray(rows) || !rows.length) return null;
  return <div className="my-3 rounded-xl border border-[#ead7b0] bg-[#fffaf2] p-3 text-sm"><h4 className="mb-2 font-semibold">Wholesale quantities</h4><dl className="space-y-1">{rows.map((row) => <div key={row.option} className="flex justify-between gap-4"><dt>{row.option}</dt><dd className="font-semibold">{row.qty}</dd></div>)}</dl></div>;
}
